const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        
        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }
          
          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
              
              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  } 
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function(){
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();                                    
                    }
                  }, 200);
                }
              }
            }
          });
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
colorSwatches();
})()

if (!customElements.get('card-variant-radios')) {
  class CardVariantRadios extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onVariantChange.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    onVariantChange(e) {
      const variantId = e.target.dataset.variantId;
      if (!variantId) return;
      this.addToCart(variantId);
    }

    addToCart(variantId) {
      console.log("variantId",variantId);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      console.log("formData",formData);
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(res => res.json())
        .then(response => {
          console.log("response",response);
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'card-variant-radios',
              productVariantId: variantId,
              errors: response.description,
              message: response.message
            });
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'card-variant-radios',
            productVariantId: variantId
          });

          if (this.cart) this.cart.renderContents(response);
        })
        .catch(err => console.error('Add to cart error', err));
    }
  }

  customElements.define('card-variant-radios', CardVariantRadios);
}

class MobileVariantRadios extends HTMLElement {
  constructor() {
    super();
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    this.onVariantClick = this.onVariantClick.bind(this);
  }

  connectedCallback() {
    this.variantSelector = this.closest('.variant-selector-mobile');
    if (!this.variantSelector) return;

    // this.quickAddBtn = this.variantSelector.querySelector('.product-card__quick-add');
    this.quickAddBtn = document.querySelector(`.product-card__quick-add[data-product-id="${this.dataset.productId}"]`);
    this.dropdown = this.querySelector('.dropdown-select');
    this.closeBtn = this.querySelector('.variant-close');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (this.quickAddBtn) {
      this.quickAddBtn.addEventListener('click', this.toggleDropdown);
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.closeDropdown);
    }

    // Listen for both change and click
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('click', this.onVariantClick);

    document.addEventListener('click', (e) => {
      if (!this.variantSelector.contains(e.target)) {
        this.closeDropdown();
      }
    });
  }

  toggleDropdown(e) {
    e.stopPropagation();
    if (!this.dropdown) return;
    this.dropdown.classList.toggle('active');
    document.body.classList.toggle('size-modal-open');
  }

  closeDropdown(e) {
    if (e) e.stopPropagation();
    if (!this.dropdown) return;
    this.dropdown.classList.remove('active');
    document.body.classList.remove('size-modal-open');
  }

  onVariantChange(e) {
    if (e.target.matches('input[type="radio"][data-variant-id]')) {
      const variantId = e.target.dataset.variantId;
      if (variantId) this.addToCart(variantId);
    }
  }

  onVariantClick(e) {
    if (e.target.matches('input[type="radio"][data-variant-id]')) {
      const variantId = e.target.dataset.variantId;
      console.log("variantId",variantId);
      // Case: if input already checked, `change` won’t fire → handle here
      if (variantId && e.target.checked) {
        this.addToCart(variantId);
      }
    }
  }

  addToCart(variantId) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
      formData.append('sections_url', window.location.pathname);
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then(res => res.json())
      .then(response => {
        console.log("response",response);
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'mobile-variant-radios',
            productVariantId: variantId,
            errors: response.description,
            message: response.message
          });
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'mobile-variant-radios',
          productVariantId: variantId
        });

        if (this.cart) this.cart.renderContents(response);
        this.closeDropdown();
      })
      .catch(err => console.error('Add to cart error', err));
  }
}

customElements.define('mobile-variant-radios', MobileVariantRadios);